<!--
 * @Date: 2023-08-01
 * @Description: 售后两种页面写一起
-->
<template>
    <div class="box" v-loading.fullscreen.lock="state.loading" element-loading-text="搜索中...">
        <div class="main-wrap">
            <CompHeader title="售后管理" />
            <div class="member_inner">
                <div class="top_tips">
                    <i class="icon-info2"></i>
                    <p>
                        “待处理工单”和“申诉单”会影响结算！请尽快处理：<br>
                        1. 待处理工单和申诉单 ≥15 将影响中款結算；2. 待处理工单和申诉单 ≥5 将影响尾款結算。
                    </p>
                </div>
                <div class="statistics">
                    <div :class="[{'active':formAfterSale.aftersale_type == 0}]" @click.stop="getInitList">
                        <p class="num">{{ state.sales_num }}</p>
                        <p>待退款</p>
                    </div>
                    <div :class="[{'active':formAfterSale.aftersale_type == 1}]" @click.stop="goComplainManage(1)">
                        <p class="num">{{ saleState.order_total }}</p>
                        <p>待售后</p>
                    </div>
                    <div :class="[{'active':formAfterSale.aftersale_type == 3}]" @click.stop="goComplainManage(3)">
                        <p :class="['num','other',{'striking':saleState.work_total > 0}]">{{ saleState.work_total }}</p>
                        <p>
                            待处理工单
                            <el-popover
                                :visible="visible3"
                                placement="bottom"
                                :width="150"
                                effect="dark"
                                trigger="click"
                                content="平台创建的工单"
                            >
                                <template #reference>
                                    <i class="icon-info2" @click.stop="visible3 = !visible3"></i>
                                </template>
                            </el-popover>
                        </p>
                    </div>
                    <div :class="[{'active':formAfterSale.aftersale_type == 2}]" @click.stop="goComplainManage(2)">
                        <p :class="['num','other',{'striking':saleState.appeal_total > 0}]">{{ saleState.appeal_total }}</p>
                        <p>
                            售后申诉单
                            <el-popover
                                :visible="visible2"
                                placement="bottom"
                                effect="dark"
                                :width="150"
                                content="申诉处理完成后，请联系平台客服反馈处理结果关闭申诉单"
                            >
                                <template #reference>
                                    <i class="icon-info2" @click.stop="visible2 = !visible2"></i>
                                </template>
                            </el-popover>
                        </p>
                    </div>
                </div>
            </div>
            <!-- 退款 -->
            <div class="member_inner" v-if="state.pageType == 0" style="margin: 20px 0 0 0;">
                <div class="header">
                    退款订单
                </div>
                <el-form :inline="true" :model="formInline" label-width="100px" class="refund-form-inline">
                    <el-form-item label="摩点订单号">
                        <el-input v-model="formInline.order_id" placeholder="请输入订单号" clearable />
                    </el-form-item>
                    <el-form-item label="收件人手机号">
                        <el-input v-model="formInline.addressMobile" placeholder="请输入手机号" clearable />
                    </el-form-item>
                    <el-form-item label="退款状态" label-width="100px">
                        <el-select v-model="formInline.refundStatus">
                            <el-option label="全部状态" value="0" />
                            <el-option label="退款待审核" value="1" />
                            <el-option label="退款中" value="2" />
                            <el-option label="已退款" value="3" />
                            <el-option label="申诉待审核" value="4" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="退款类型" label-width="100px">
                        <el-select v-model="formInline.refundType">
                            <el-option label="全部" value="0" />
                            <el-option label="众筹中退款" value="1" />
                            <el-option label="众筹结束后退款" value="2" />
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-button type="primary" @click="getList">搜索</el-button>
                <el-popover class="popover" placement="right" :width="400" :visible="step1Pop" trigger="click">
                    <template #reference>
                        <el-button @click="exportExcexTab1">
                            导出
                        </el-button>
                    </template>
                    <el-icon class="popover-icon" @click="step1Pop = false">
                        <Close />
                    </el-icon>
                    <el-progress :percentage="saleState.exportExcexRate" />
                    <div class="export-tips">导出完成前，请不要关闭当前网页</div>
                </el-popover>
                <div class="tips_field">
                    1、众筹开始至众筹结束最后一小时前，支持者有权随时取消订单并申请退款，退款申请将由系统自动处理，发起人无需介入；<br>
                    2、众筹成功后如果发起人逾期未发货，支持者有权申请退款，退款申请需由发起人3日内完成其审批处理，逾期将自动退款；<br>
                    3、发起人未和用户达成一致拒绝退款，支持者有权向平台提交申诉，平台客服将介入沟通双方确认情况，协商一致完成处理；<br>
                    4、请在同意退款申请前，务必确认该订单是否处于以下状态：已发快递且未上传发货信息至摩点发货系统，否则将造成损失；
                    <el-button @click.stop="goHelpCenter" size="small" style="display:none;">联系客服</el-button>
                </div>
                <div class="table">
                    <el-pagination class="pagination" v-model:current-page="state.page" @update:page-size="changePagesize"
                        @update:current-page="changePage" :page-size="state.page_size" background
                        :page-sizes="[10, 20, 30, 40, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
                        :total="state.total" />
                    <el-table :data="state.tableData"  @sort-change="tableSortChange">
                        <el-table-column prop="order_id" label="摩点订单号" width="210" />
                        <el-table-column prop="refund_id" label="退款单号" width="210" />
                        <el-table-column prop="reward_title" label="回报档标题" width="172" />
                        <el-table-column prop="reward_num" label="众筹数量" width="100" />
                        <el-table-column prop="pay_amount" label="实付金额" width="100">
                            <template #default="scope">
                                ¥{{ scope.row.pay_amount }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="refund_amount" label="退款金额" width="100">
                            <template #default="scope">
                                ¥{{ scope.row.refund_amount }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="订单备注" width="200" />
                        <el-table-column prop="refund_ctime" label="申请退款时间" width="174" sortable>
                            <template #default="scope">
                            {{ scope.row.refund_ctime }}
                        </template>
                        </el-table-column>
                        <el-table-column prop="reward_type_name" label="发货方式" width="100" />
                        <el-table-column prop="address_name" label="收件人姓名" width="110" />
                        <el-table-column prop="address_mobile" label="收件人手机号" width="210" />
                        <el-table-column prop="address" label="收件人地址" width="200" />
                        <el-table-column prop="refund_status_name" label="状态" width="200" />
                        <el-table-column label="用户昵称/ID" width="324">
                            <template #default="scope">
                                <div class="userInfo">
                                    <div class="img">
                                        <CompAvtor :img_src="scope.row.user_icon" size="30" />
                                    </div>
                                    <div class="info">
                                        <p>{{ scope.row.nickname }}</p>
                                        <span>ID {{ scope.row.user_id }}</span>
                                    </div>
                                    <el-link @click="rongim(scope.row.user_id)" :underline="false">私信</el-link>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" width="200" label="操作">
                            <template #default="scope">
                                <el-link v-for="(item, index) in scope.row.btns" :disabled="!item.type" :key="index"
                                    @click.stop="openBtn(item.type, scope.row)" :underline="false">{{ item.title
                                    }}</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination class="pagination" v-model:current-page="state.page" @update:page-size="changePagesize"
                        @update:current-page="changePage" :page-size="state.page_size"
                        :page-sizes="[10, 20, 30, 40, 50, 100]" background layout="total, sizes, prev, pager, next, jumper"
                        :total="state.total" />
                </div>
                <!-- <el-drawer v-model="state.drawerVisible" class='submitDrawer' :closeOnClickModal="false">
                    <template #header="{ titleId, titleClass }">
                        <h4 :id="titleId" :class="titleClass">
                            {{ state.drawerTitle }}
                            <span><i class="icon-time"></i>{{ state.contTimeTxt }}</span>
                        </h4>
                    </template>
                    <div v-if="state.drawType != 'look_refund'" class="title top">退款信息</div>
                    <template v-if="state.refund_node == 0 && !state.refund_refuse">
                        <p>项目众筹期间，支持者有权随时取消支持订单并申请退款。您可以在倒计时结束前：</p>
                        <p style="padding: 8px 0 17px 0">
                            1.主动联系用户，协商取消退款。<br>
                            2.点击“同意退款申请”按钮，系统将立即执行退款。<br>
                            3.不做任何操作，系统将在倒计时结束后自动执行退款。<br>
                        </p>
                    </template>
                    <template v-if="state.refund_node == 1 && !state.refund_refuse">
                        <p>项目众筹成功后，若回报发放延期或可能延期，发起者应及时发布更新公告说明延期原因和预期发放日期，如有支持者因此要求退款，发起者应与支持者友好协商并妥善处理退款申请。您可以在倒计时结束前：</p>
                        <p style="padding: 8px 0 17px 0">
                            1.主动联系用户，协商取消退款。<br>
                            2.点击“同意退款申请”按钮，系统将立即执行退款。<br>
                            3.不做任何操作，系统将在倒计时结束后自动拒绝退款申请，支持者可以要求摩点介入，摩点有权根据情况自行判断是否向支持者退款，该部分退款金额将从可结算金额中扣除。<br>
                        </p>
                    </template>
                    <div class="detail">
                        <div class="column">
                            <label>订单号</label>
                            <p>{{ state.refundDetailObj.order_id }}</p>
                        </div>
                        <div class="column">
                            <label>订单状态</label>
                            <p>{{ state.refundDetailObj.order_status_name }}</p>
                        </div>
                        <div class="column">
                            <label>档位名称</label>
                            <p>{{ state.refundDetailObj.reward_title }}</p>
                        </div>
                        <div class="column">
                            <label>退款金额</label>
                            <p>{{ state.refundDetailObj.refund_price }}</p>
                        </div>
                        <div class="column">
                            <label>收件人姓名</label>
                            <p>{{ state.refundDetailObj.address_name }}</p>
                        </div>
                        <div class="column">
                            <label>收件人手机号</label>
                            <p>{{ state.refundDetailObj.address_mobile }}</p>
                        </div>
                        <div class="column">
                            <label>退款理由</label>
                            <p>{{ state.refundDetailObj.apply_reson }}</p>
                        </div>
                        <div class="column">
                            <label>申请时间</label>
                            <p>{{ state.refundDetailObj.ctime }}</p>
                        </div>
                    </div>
                    <div v-if="state.refund_refuse" class="title">拒绝退款理由</div>
                    <el-input v-if="state.refund_refuse" v-model="state.reason" type="textarea" maxlength="50"
                        placeholder="请填写拒绝理由" show-word-limit />
                    <template #footer>
                        <el-button v-for="(item, btnIndex) in state.refundDetailObj.btns" :key="btnIndex" type="primary"
                            @click.stop="openBtn(item.type)">{{ item.title }}</el-button>
                    </template>
                </el-drawer> -->
                <drawRefund v-if="state.drawerVisible" drawerTitle="待处理退款"
                    @openBtn="({ type, reason }) => { openBtn(type) }" @dialogBack="state.drawerVisible = false"
                    :state="state" />
                <drawRefund v-if="state.refund_refuse" :row="state.row" :refund_refuse="true" drawerTitle="拒绝退款申请"
                    @openBtn="({ type, reason }) => { state.reason = reason; openBtn(type) }"
                    @dialogBack="state.refund_refuse = false" :state="state" />
                <drawRefund v-if="state.drawerVisibleLook_refund" :row="state.row" :loook_refund="true" drawerTitle="退款记录"
                    @openBtn="({ type, reason }) => { state.reason = reason; openBtn(type) }"
                    @dialogBack="state.drawerVisibleLook_refund = false" :state="state" />
            </div>
            <!-- 售后 -->
            <div class="member_inner" v-if="state.pageType == 1" style="margin: 20px 0 0 0;">
                <div class="header">
                    售后订单
                </div>
                <el-form :inline="true" :model="formAfterSale" label-width="120px" class="refund-form-inline">
                    <el-form-item label="售后状态" class="boldTitle">
                        <el-select v-model="formAfterSale.status">
                            <el-option label="全部" :value="0" />
                            <el-option label="待处理" :value="1" />
                            <el-option label="处理中" :value="2" />
                            <el-option label="已结束" :value="3" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="售后单号">
                        <el-input v-model="formAfterSale.aftersale_id" placeholder="请输入售后单号" clearable />
                    </el-form-item>
                    <el-form-item label="摩点订单号">
                        <el-input v-model="formAfterSale.order_id" placeholder="请输入订单号" clearable />
                    </el-form-item>
                    <el-form-item label="" class="inputSelect">
                        <el-select class="title" v-model="formAfterSale.query_type" @change="formAfterSale.query_data = ''">
                            <el-option label="请选择" :value="0" />
                            <el-option label="收件人姓名" :value="1" />
                            <el-option label="收件人手机号" :value="2" />
                            <el-option label="用户ID" :value="3" />
                        </el-select>
                        <el-input v-if="formAfterSale.query_type == 0" v-model="formAfterSale.query_data"
                            placeholder="请输入" clearable />
                        <el-input v-if="formAfterSale.query_type == 1" v-model="formAfterSale.query_data"
                            placeholder="请输入收件人姓名" clearable />
                        <el-input v-if="formAfterSale.query_type == 2" v-model="formAfterSale.query_data"
                            placeholder="请输入收件人手机号" clearable @input="handleMobileInput" />
                        <el-input v-if="formAfterSale.query_type == 3" v-model="formAfterSale.query_data"
                            placeholder="请输入用户ID" clearable />
                        <el-input v-if="formAfterSale.query_type == 4" v-model="formAfterSale.query_data"
                            placeholder="请输入用户昵称" clearable />
                    </el-form-item>
                    <el-form-item label="售后原因">
                        <el-select v-model="formAfterSale.apply_reson_type">
                            <el-option label="全部" :value="0" />
                            <el-option label="少件/漏发/错发" :value="1" />
                            <el-option label="破损/磕角/污渍/变形/裂痕" :value="2" />
                            <el-option label="质量问题" :value="3" />
                            <el-option label="无物流信息/物流信息停滞" :value="4" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审核状态">
                        <el-select v-model="formAfterSale.cp_audit_status">
                            <el-option label="全部" :value="0" />
                            <el-option label="待审核" :value="1" />
                            <el-option label="审核未通过" :value="2" />
                            <el-option label="审核通过" :value="3" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="售后发起方">
                        <el-select v-model="formAfterSale.user_type">
                            <el-option label="全部" :value="0" />
                            <el-option label="用户" :value="1" />
                            <el-option label="平台" :value="2" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="售后类型">
                        <el-select v-model="formAfterSale.aftersale_type">
                            <el-option label="全部" :value="0" />
                            <el-option label="用户售后单" :value="1" />
                            <el-option label="用户申诉单" :value="2" />
                            <el-option label="平台工单" :value="3" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="解决方案">
                        <el-select v-model="formAfterSale.process_type">
                            <el-option label="全部" :value="0" />
                            <el-option label="部分退款" :value="1" />
                            <el-option label="换货" :value="2" />
                            <el-option label="补发" :value="3" />
                            <el-option label="沟通解决" :value="4" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="补/换商品已发货">
                        <el-select v-model="formAfterSale.aftersale_deliver_status">
                            <el-option label="全部" :value="0" />
                            <el-option label="是" :value="1" />
                            <el-option label="否" :value="2" />
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-button type="primary" @click.stop="getAfterSaleList">搜索</el-button>
                <el-button @click.stop="empty">清空</el-button>
                <el-button @click.stop="exportExcex">导出</el-button>
                <!-- <el-popover class="popover" placement="right" :width="400" :visible="step1Pop" trigger="click">
                    <template #reference>
                        <el-button @click="exportExcex">
                            导出
                        </el-button>
                    </template>
                    <el-icon class="popover-icon" @click="step1Pop = false">
                        <Close />
                    </el-icon>
                    <el-progress :percentage="state.exportExcexRate" />
                    <div class="export-tips">导出完成前，请不要关闭当前网页</div>
                </el-popover> -->
                <div class="tips_field afterSale">
                    <i class="icon-warning"></i>
                    <div>
                        <p>状态为“申诉待审核”的订单为摩点平台正在处理的订单（未处理完成时，此状态订单不能发货），您可以联系摩点客服了解详情。</p>
                        <p>1、项目众筹期间，支持者有权随时取消支持订单并申请退款。2、项目众筹结束后，如果项目逾期违未发货，支持者可能申请退款。请在同意退款申请前确认该订单是否处于以下状态：已发快递&未上传发货信息至摩点系统，否则可能造成损失。
                        </p>
                    </div>
                    <el-button @click.stop="goHelpCenter" size="small">联系客服</el-button>
                </div>
                <div class="table">
                    <el-pagination class="pagination" v-model:current-page="saleState.salePage"
                        @update:page-size="changeSalePagesize" @update:current-page="changeSalePage" background
                        layout="total, sizes, prev, pager, next, jumper" :total="saleState.saleTotal" />
                    <el-table :data="saleState.saleTableData">
                        <el-table-column prop="order_id" label="摩点订单号" width="210" />
                        <el-table-column prop="aftersale_id" label="售后单号" width="210" />
                        <el-table-column prop="status_name" label="售后状态" width="136" />
                        <el-table-column prop="process_type_str" label="处理方式" width="136" />
                        <el-table-column prop="apply_time" label="申请时间" width="174" />
                        <el-table-column prop="aftersale_type_name" label="售后类型" width="136" />
                        <el-table-column prop="reward_title" label="回报档标题" width="172" />
                        <el-table-column prop="reward_num" label="众筹数量" width="100" />
                        <el-table-column prop="pay_amount" label="实付金额" width="100">
                            <template #default="scope">
                                {{scope.row.pay_amount ? '¥'+scope.row.pay_amount : ''}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="pay_success_time" label="付款时间" width="184" />
                        <el-table-column prop="name_and_mobile" label="收件人姓名/手机号" width="156" />
                        <el-table-column prop="user_id_and_nickname" label="用户ID/昵称" width="224">
                            <template #default="scope">
                                <div class="userInfo">
                                    <div class="img">
                                        <CompAvtor :img_src="scope.row.icon" size="30" />
                                    </div>
                                    <div class="info">
                                        <p>{{ scope.row.nickname }}</p>
                                        <span>ID {{ scope.row.userId }}</span>
                                    </div>
                                    <el-link @click="rongim(scope.row.userId)" :underline="false">私信</el-link>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="user_type_name" label="发起方" width="136" />
                        <el-table-column prop="process_type_name" label="解决方案" width="136" />
                        <el-table-column prop="is_related" label="关联单" width="100">
                            <template #default="scope">
                                <el-link v-if="Number(scope.row.is_related) == 1" @click.stop="relatedOrder(scope.row.order_id)">是</el-link>
                                <p v-else>--</p>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="136">
                            <template #default="scope">
                                <el-link v-for="(item, index) in scope.row.btn_list" :key="index"
                                    @click.stop="openSaleOpBtn(item.type, scope.row)" :underline="false">{{ item.title
                                    }}</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination class="pagination" v-model:current-page="saleState.salePage"
                        @update:page-size="changeSalePagesize" @update:current-page="changeSalePage" background
                        layout="total, sizes, prev, pager, next, jumper" :total="saleState.saleTotal" />
                </div>
                <!-- 售后审核和查看 -->
                <el-drawer v-model="saleState.saleOpDrawerVisible" size="600px" :title="saleState.aftersale_type == 2 ? '售后申诉审核' : '售后审核'" :closeOnClickModal="false">
                    <div class="afterSaleDrawerContent">
                        <template v-if="saleState.isExamine">
                            <div class="title">
                                <p>申请信息</p>
                                <el-button @click.stop="rongim(saleState.userId)" size="small"><i class="icon-customer"></i>联系用户</el-button>
                            </div>
                            <div class="saleApplyInfo">
                                <div class="col">
                                    <p>订单号</p>
                                    <div class="right">
                                        <p>{{saleState.orderDetail && saleState.orderDetail.order_id}}</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <p>提交申请时间</p>
                                    <div class="right">
                                        <p>{{saleState.orderDetail && saleState.orderDetail.apply_time}}</p>
                                    </div>
                                </div>
                                <div v-if="saleState.orderDetail && saleState.orderDetail.apply_reson_type_str" class="col">
                                    <p>售后原因</p>
                                    <div class="right">
                                        <p>{{saleState.orderDetail && saleState.orderDetail.apply_reson_type_str}}</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <p>补充凭证和描述</p>
                                    <div class="right">
                                        <p>{{saleState.orderDetail && saleState.orderDetail.apply_reson_content}}</p>
                                        <div v-if="(saleState.imgList && saleState.imgList.length > 0) || (saleState.videoList && saleState.videoList.length > 0)" class="proof">
                                            <el-image v-for="(imgItem, imgIndex) in saleState.imgList" :key="imgIndex" class="big-image"
                                                :src="imgItem" fit="contain" @click="saleState.currentIndex = imgIndex" :initial-index="saleState.currentIndex" :preview-src-list="saleState.imgList" />
                                            <div v-for="(videoItem, videoIndex) in saleState.videoList" :key="videoIndex" class="videoItem" @click.stop="getVideo(videoItem.url)">
                                                <el-image :src="videoItem.video_cover" fit="contain" />
                                                <div class="video_bg">
                                                    <i class="icon-video"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="examine">
                                <p class="left_title">审核<i>*</i></p>
                                <el-radio-group v-model="saleState.examine">
                                    <el-radio :label="3" size="large" border>通过申请</el-radio>
                                    <el-radio :label="2" size="large" border>拒绝申请</el-radio>
                                </el-radio-group>
                            </div>
                            <div v-if="Number(saleState.examine) == 3" class="saleOpBottom">
                                <div class="col">
                                    <p class="left_title">解决方案<i>*</i></p>
                                    <el-radio-group v-model="saleState.opType">
                                        <el-radio :label="1" size="large" border>部分退款</el-radio>
                                        <el-radio :label="2" size="large" border>换货</el-radio>
                                        <el-radio :label="3" size="large" border>补发</el-radio>
                                        <el-radio :label="4" size="large" border>已和用户沟通，用户同意撤销售后申请</el-radio>
                                    </el-radio-group>
                                </div>
                                <p class="tips">请先和用户沟通，再选择对应的解决方案</p>
                                <!-- 部分退款 -->
                                <div v-if="saleState.opType == 1" class="col bottom">
                                    <p class="left_title">退款金额<i>*</i></p>
                                    <el-input v-model="saleState.refund_amount" :placeholder="'输入退款金额，最大为¥'+saleState.max_refund_amount" class="refund_amount"
                                        @input="handleMoneyInput">
                                        <template #append>元</template>
                                    </el-input>
                                </div>
                                <p v-if="saleState.cashback_state == 1 && saleState.cashback_message" class="tips cashback_state">{{saleState.cashback_message}}</p>
                                <p v-if="saleState.opType == 1" class="tips">注意:
                                    1、请确认订单下所有商品已完成发货，退款后不能再操作发货；2、退款将从剩余可结算金额中扣除，如余额不足可能会导致退款失败，请与您的项目经理联系</p>
                                <!-- 换货 -->
                                <div v-if="saleState.opType == 2" class="col bottom">
                                    <p class="left_title">寄回地址<i>*</i></p>
                                    <div class="gridAddress">
                                        <el-select placeholder="省" v-model="saleState.province_id" @change="changeProvince">
                                            <el-option v-for="item in saleState.AddressData" :key="item.id" :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <el-select placeholder="市" v-model="saleState.city_id" @change="changeCity">
                                            <el-option v-for="item in saleState.AddressData1" :key="item.id" :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <el-select placeholder="区" v-model="saleState.area_id" @change="changeArea">
                                            <el-option v-for="item in saleState.AddressData2" :key="item.id" :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div v-if="saleState.opType == 2" class="extraAddress">
                                    <el-input v-model.trim="saleState.address" placeholder="请填写详细地址" clearable />
                                    <el-input v-model.trim="saleState.name" placeholder="联系人姓名" clearable />
                                    <el-input v-model.trim="saleState.mobile" placeholder="联系人手机号" @input="handleDeliverMobileInput" clearable />
                                </div>
                                <div v-if="saleState.opType == 3" class="col bottom start">
                                    <p class="left_title">补发地址<i>*</i></p>
                                    <div class="show">
                                        <p>{{saleState.reissue_address && saleState.reissue_address.address_name}} {{saleState.reissue_address && saleState.reissue_address.address_phone}}</p>
                                        <p class="address">{{saleState.reissue_address && saleState.reissue_address.address}}</p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="Number(saleState.examine) == 2" class="saleOpBottom">
                                <div class="col start">
                                    <p class="left_title">拒绝原因<i>*</i></p>
                                    <el-input v-model="saleState.reason" type="textarea" maxlength="200"
                                        placeholder="请详细说明申请理由，如已发货状态、无法完成的原因等" show-word-limit />
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div v-for="(infos,infoIndex) in saleState.process_item_infos" :key="infoIndex">
                                <div class="title" style="padding:20px 0 10px 0;">
                                    <p>{{infos.process_title}}</p>
                                    <el-button v-if="infoIndex == 0" @click.stop="rongim(saleState.userId)" size="small"><i class="icon-customer"></i>联系用户</el-button>
                                </div>
                                <div class="saleApplyInfo">
                                    <div class="col" v-for="(item, index) in infos.audit_info" :key="index">
                                        <p>{{item.title}}</p>
                                        <div class="right">
                                            <p>{{item.value}}</p>
                                        </div>
                                    </div>
                                    <div v-if="(infos.imgList && infos.imgList.length > 0) || (infos.videoList && infos.videoList.length > 0)" class="col">
                                        <p>凭证</p>
                                        <div class="right">
                                            <div class="proof">
                                                <el-image v-for="(auditImgItem, auditImgIndex) in infos.imgList" :key="auditImgIndex" class="big-image"
                                                    :src="auditImgItem" fit="contain" @click="saleState.currentIndex = auditImgIndex" :initial-index="saleState.currentIndex" :preview-src-list="infos.imgList" />
                                                <div v-for="(auditVideoItem, auditVideoIndex) in infos.videoList" :key="auditVideoIndex" class="videoItem" @click.stop="getVideo(auditVideoItem.url)">
                                                    <el-image :src="auditVideoItem.video_cover" fit="contain" />
                                                    <div class="video_bg">
                                                        <i class="icon-video"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <el-drawer
                            title="视频预览"
                            size="600px"
                            :append-to-body="true"
                            v-model="saleState.innerDrawer">
                            <video style="width:400px;height:300px;margin:0 auto;display: block;" :src="saleState.videoUrl" controls="controls"></video>
                        </el-drawer>
                    </div>
                    <template #footer>
                        <el-button v-if="saleState.isExamine" @click.stop="closeSaleDialog">取消</el-button>
                        <el-button type="primary" @click.stop="orderAudit">确定</el-button>
                    </template>
                </el-drawer>
                <!-- 发货 -->
                <el-drawer v-model="saleState.deliverDrawerVisible" size="400px" title="发货" :closeOnClickModal="false">
                    <div class="afterSaleDrawerContent deliver">
                        <div class="title">
                            <p>寄回信息</p>
                        </div>
                        <div class="saleApplyInfo">
                            <div class="col">
                                <p>收货人</p>
                                <div class="right">
                                    <p>{{saleState.reissue_address && saleState.reissue_address.address_name}}</p>
                                </div>
                            </div>
                            <div class="col">
                                <p>手机号</p>
                                <div class="right">
                                    <p>{{saleState.reissue_address && saleState.reissue_address.address_phone}}</p>
                                </div>
                            </div>
                            <div class="col">
                                <p>收货地址</p>
                                <div class="right">
                                    <p>{{saleState.reissue_address && saleState.reissue_address.address}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="title" style="padding:20px 0 10px 0;">
                            <p>物流公司<i>*</i></p>
                        </div>
                        <el-select v-model="saleState.express_company" placeholder="请选择物流公司">
                            <el-option label="请选择" value=""></el-option>
                            <el-option v-for="item in saleState.expressOptions" :key="item" :label="item"
                                :value="item"></el-option>
                        </el-select>
                        <el-input v-model="saleState.express_no" placeholder="请填物流单号" clearable />
                    </div>
                    <template #footer>
                        <el-button type="primary" @click.stop="postDeliver">确定</el-button>
                    </template>
                </el-drawer>
                <!-- 工单详情 -->
                <el-drawer v-model="saleState.workOrderDrawerVisible" size="600px" title="平台工单" :closeOnClickModal="false" :before-close="handleClose">
                    <div class="afterSaleDrawerContent">
                        <template v-if="saleState.orderDetail && saleState.orderDetail.length > 0">
                            <div v-for="(item, index) in saleState.orderDetail" :key="index" :class="{'colTop':index > 0}">
                                <div class="title">
                                    <p>{{item.main_title}}</p>
                                </div>
                                <div class="saleApplyInfo">
                                    <div class="col" v-for="(col,cindex) in item.items" :key="cindex">
                                        <p>{{col.title}}</p>
                                        <div class="right">
                                            <p v-if="col.title != '凭证：'" v-html="col.value"></p>
                                            <div v-else class="proof" style="padding:0;">
                                                <el-image v-for="(colProofItem, colProofIndex) in JSON.parse(col.value)" :key="colProofIndex" class="big-image"
                                                    :src="colProofItem.url" @click="saleState.currentIndex = colProofIndex" :initial-index="saleState.currentIndex" :preview-src-list="JSON.parse(col.value).map(function(obj) {return obj.url;})"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <template v-if="saleState.orderDetail && saleState.orderDetail.length > 0 && [1,2].includes(saleState.orderDetail[saleState.orderDetail.length - 1].audit_status)">
                                <div class="title" style="padding:20px 0 10px 0;">
                                    <p>处理方案</p>
                                </div>
                                <div class="saleOpBottom">
                                    <div class="col start">
                                        <p class="left_title">处理依据<i>*</i></p>
                                        <el-input v-model="saleState.audit_attachment" type="textarea" maxlength="200"
                                            placeholder="请详细说明申请理由，如已发货状态、无法完成的原因等" show-word-limit />
                                    </div>
                                    <div class="col start" @click="coverClick" style="margin:20px 0 0 0;">
                                        <p class="left_title">处理依据<i>*</i></p>
                                        <div class="audit_content">
                                            <div v-for="(auditItem, auditIndex) in saleState.audit_content" :key="auditIndex">
                                                <img :src="auditItem">
                                                <div class="op" @click.stop="saleState.audit_content.splice(auditIndex,1)">
                                                    <i class="icon-closs" />
                                                </div>
                                            </div>
                                            <div v-if="saleState.audit_content.length < 6" class="upload">
                                                <i class="icon-plus"></i>
                                                <p>点击上传图片</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                    <template #footer>
                        <el-button v-if="saleState.orderDetail && saleState.orderDetail.length > 0 && [1,2].includes(saleState.orderDetail[saleState.orderDetail.length - 1].audit_status)" @click.stop="closeWorkDialog">暂不处理</el-button>
                        <el-button v-else @click.stop="closeWorkDialog">确定</el-button>
                        <el-button v-if="saleState.orderDetail && saleState.orderDetail.length > 0 && [1,2].includes(saleState.orderDetail[saleState.orderDetail.length - 1].audit_status)" type="primary" @click.stop="workOrderAudit">提交处理结果</el-button>
                    </template>
                </el-drawer>
                <!-- 日志 -->
                <el-drawer v-model="saleState.saleLogDrawerVisible" size="600px" title="日志" :closeOnClickModal="false">
                    <div class="afterSaleDrawerContent">
                        <el-table :data="saleState.orderLogList" :default-sort="{ prop: 'ctime', order: 'descending' }"
                            style="width: 100%">
                            <el-table-column prop="ctime" label="操作时间" sortable width="200" />
                            <el-table-column prop="cuser_name" label="操作人" width="150" />
                            <el-table-column prop="log_message" label="操作内容" />
                        </el-table>
                    </div>
                    <template #footer>
                        <el-button type="primary" @click.stop="saleState.saleLogDrawerVisible = false">确定</el-button>
                    </template>
                </el-drawer>

                 <!-- 上传协商凭证 -->
                <el-drawer v-model="saleState.appealNegoAddDrawerVisible" size="600px" title="上传协商结果" :closeOnClickModal="false" :before-close="handleCloseAppealNegoDrawer">
                    <div class="afterSaleDrawerContent">
                        <div style="padding:0px 0 20px 0;">
                            <p>用户对售后结果表示不满意，并已向平台客服发起申诉。为了协助平台客服快速完成处理，请尽快提交与用户的协商结果。</p>
                        </div>
                        <div class="saleOpBottom">
                            <div class="col start">
                                <p class="left_title">协商结果<i>*</i></p>
                                <el-input v-model="saleState.appealNegoAddContent" type="textarea" maxlength="200"
                                    placeholder="您与用户最终协商的售后方案，比如承诺退款金额或补发/换货时间及物流单号等。" show-word-limit />
                            </div>
                            <div class="col start" @click="coverClick" style="margin:20px 0 0 0;">
                                <p class="left_title">上传佐证</p>
                                <div class="audit_content">
                                    <div v-for="(auditItem, auditIndex) in saleState.appealNegoAddImages" :key="auditIndex">
                                        <img :src="auditItem">
                                        <div class="op" @click.stop="saleState.appealNegoAddImages.splice(auditIndex,1)">
                                            <i class="icon-closs" />
                                        </div>
                                    </div>
                                    <div v-if="saleState.appealNegoAddImages.length < 5" class="upload">
                                        <i class="icon-plus"></i>
                                        <p>点击上传图片</p>
                                    </div>
                                </div>
                            </div>
                            <p style="margin: 10px 0 0 120px; font-size: 12px; color: #7F7F7F;">支持JPG、PNG 格式，最多可上传5张图片</p>
                        </div>
                    </div>
                    <template #footer>
                        <el-button  @click.stop="handleCloseAppealNegoDrawer">取消</el-button>
                        <el-button type="primary"  @click.stop="handleSubmitAppealNegoInfo">提交</el-button>
                    </template>
                </el-drawer>

                <!-- 查看协商历史 -->
                <el-drawer v-model="saleState.appealNegoLogDrawerVisible" size="600px" title="协商历史" :closeOnClickModal="false">
                        <div class="appealLogItem" v-for="(item, index) in saleState.appealLogList" :key="index">
                            <div class="item">
                                <div class="left-title">提交时间</div>
                                {{item.ctime}}
                            </div>
                            <div class="item">
                                <div class="left-title">协商结果</div>
                                {{item.content}}
                            </div>
                            <div  class="item" v-if="(item.attachment && item.attachment.length > 0)">
                               <div class="left-title">上传佐证</div>
                                <div class="images">
                                    <el-image v-for="(colProofItem, colProofIndex) in item.attachment" :key="colProofIndex" class="big-image"
                                    :src="colProofItem.url" @click="saleState.currentIndex = colProofIndex" :initial-index="saleState.currentIndex" :preview-src-list="item.attachment.map(function(obj) {return obj.url;})"/>
                                </div>
                            </div>
                        </div>   
                    <template #footer>
                        <el-button type="primary" @click.stop="saleState.appealNegoLogDrawerVisible = false">确定</el-button>
                    </template>
                </el-drawer>


            </div>
        </div>
    </div>
    <Uploader ref="uploaderChild" :accept="'image/jpg,image/jpeg,image/png'" :minWidth="0" :minHeight="0"
        @onSuccess="handleSuccess" />
</template>
<script setup>
import { ref, reactive, onBeforeMount } from 'vue'
import { getRefundStatistics, getRefundManager, getRefundDetail, postRefundAudit, getAddressData, getExpressCompanyList, postOrderDeliver, getSaleOrderStatistics, getSaleOrderManager, getSaleOrderDetail, getSaleOrderLog, getWorkOrderDetail, postOrderAudit, postWorkOrderAudit, GetUserInfo, getSaleOlderExport, showVideoList, getManagerDownload, getQueryManagerDownload, postAppealNegoAddInfo, getAppealNegoLogInfo, checkRefundCashback } from '@/api/index'
import { useRoute } from "vue-router";
import { useStore } from 'vuex'
import CompHeader from "@@/common/header.vue";
import CompAvtor from "@@/compose/avtor.vue";
import drawRefund from "./drawRefund.vue";
import { ElMessageBox } from "element-plus";

import domain from '@/service/domain'
import tools from '@/utils/tools.js'
const route = useRoute()
const store = useStore()
let timer = null;
let moneyInputTimer = null; // 新增的定时器变量
const domain_zhongchou = domain.zhongchou;
// const domain_me = domain.me;
const pro_id = route.params.id
const order_id = route.query.order_id
const visible2 = ref(false)
const visible3 = ref(false)
const step1Pop = ref(false)
const state = reactive({
    row: {},
    refund_refuse: false,
    drawerVisibleLook_refund: false,
    loading: false,
    sales_num: 0,
    com_num: 0,
    sort: '',
    field: '',
    page: 1,
    page_size: 10,
    total: 0,
    tableData: [],
    drawerVisible: false,
    drawType: 'look_refund',
    drawerTitle: '退款记录',
    contTimeTxt: '0天00时00分00秒',
    refund_node: 1, // 退款节点【0=项目结束前 1=项目结束后】
    refundDetailObj: {},
    reason: '',
    pageType: 0, // 0 退款 1 售后
})
const saleState = reactive({
    order_total: 0, //售后申请单统计
    work_total: 0, //客服工单统计
    appeal_total: 0, //申诉单统计
    salePage: 1,
    salePageSize: 10,
    saleTotal: 0,
    saleTableData: [],
    saleOpDrawerVisible: false,
    imgList: [],
    videoList: [],
    auditImgList: [],
    auditVideoList: [],
    examine: '',
    opType: '',
    refund_amount: '',
    province_id: '',
    city_id: '',
    area_id: '',
    province: '',
    city: '',
    county: '',
    AddressData: [],
    AddressData1: [],
    AddressData2: [],
    AddressData3: [],
    address: '',
    name: '',
    mobile: '',
    deliverDrawerVisible: false,
    express_company: '',
    express_no: '',
    workOrderDrawerVisible: false, // 售后工单drawer
    audit_content: [], // 工单审核凭证
    audit_attachment: '', // 工单审核内容
    aftersale_id: '', // 售后单id
    aftersale_type: 1, // 类型 1 售后 3 工单 2 申诉单
    saleLogDrawerVisible: false, // 售后日志drawer

    appealNegoAddDrawerVisible: false, //上传协商凭证drawer
    appealNegoAddContent: '', //上传协商凭证填写内容
    appealNegoAddImages: [], //上传协商凭证图片
    appealNegoLogDrawerVisible: false, //查看协商凭证drawer
    appealLogList: [], //协商历史数组

    orderDetail: {}, // 售后单详情
    reissue_address: {}, // 换货地址
    orderLogList: [], // 售后单日志
    audit_info: [], // 展示审核信息
    work_cp_audit_info: [], // 展示CP审核信息
    aftersale_type_name: '', // 工单详情标题
    to_user_id: 0,
    isExamine:true, // 是否是审核，默认是
    max_refund_amount: 0, //最大退款金额
    cashback_state: 0, // 返现状态 0、无返现 1、已返现
    cashback_message: '', // 返现消息
    admin_user_name: '',
    workProof: [], // 工单展示
    exportExcexRate: 0, // 导出进度
    step1TimeOut: null, // 定时器
    deliverWait: 1000, // 导出请求check_key间隔
    innerDrawer: false,
    videoUrl: '',
    userId: 0
})
const formInline = reactive({
    order_id: '',
    addressMobile: '',
    refundStatus: '0',
    refundType: '0'
})
const formAfterSale = reactive({
    aftersale_id: '',
    order_id: '',
    query_type: 0,
    query_data: '',
    apply_reson_type: 0,
    cp_audit_status: 0,
    user_type: 0,
    status: 0,
    aftersale_type: 0,
    process_type: 0,
    aftersale_deliver_status: 0
})
const init = () => {
    // 昵称
    GetUserInfo({user_id: store.state.user.user_id}).then(async res => {
        if (res.status == 0) {
            if(res.data && res.data.user)
            saleState.admin_user_name = res.data.user.nickname || '';
        }
    })
    // 退款的统计字段
    getRefundStatistics({ pro_id: pro_id, type: 0 }).then(async res => {
        if (res.status == 0) {
            state.sales_num = res.data.apply;
        }
    })
    // 售后单统计
    getSaleOrderStatistics({ pro_id: pro_id }).then(async res => {
        if (res.status == 0) {
            saleState.order_total = res.data.order_total;
            saleState.work_total = res.data.work_total;
            if(saleState.work_total > 0){
                visible3.value = true;
            }
            saleState.appeal_total = res.data.appeal_total;
            if(saleState.appeal_total > 0){
                visible2.value = true;
            }
        }
    })
    if(order_id){
        formInline.order_id = order_id
        getList()
    }
}
// 退款的列表查询
const getList = () => {
    let option = {
        pro_id: pro_id,
        page: state.page,
        page_size: state.page_size,
        order_id: formInline.order_id,
        addressMobile: formInline.addressMobile,
        refundStatus: Number(formInline.refundStatus),
        refundType: Number(formInline.refundType),
        sort: state.sort,
        field: state.field
    }
    getRefundManager(option).then(async ({ message, status, data }) => {
        if (status == 0) {
            state.tableData.splice(0, state.tableData.length);
            state.total = data.total
            console.log(saleState.saleTotal)
            if (data.list) {
                state.tableData.push(...data.list);
            }
        } else {
            tools.confirm(message);
        }
    })
}
// 售后的列表查询
const getAfterSaleList = () => {
    const option = Object.assign({
        pro_id: pro_id,
        page: saleState.salePage,
        page_size: saleState.salePageSize
    }, formAfterSale)
    getSaleOrderManager(option).then(async res => {
        if (res.status == 0) {
            saleState.saleTotal = res.data.total;
            saleState.saleTableData = [];
            if (res.data.list) {
                saleState.saleTableData.push(...res.data.list);
            }
        } else {
            tools.confirm(res.message);
        }
    })
}
onBeforeMount(async () => {
    init();
    getAddressDataFn();
    getExperssList();
});
const getInitList = () => {
    formAfterSale.aftersale_type = 0;
    formInline.refundStatus = '1';
    state.pageType = 0;
    // if (state.sales_num == 0) {
    //     return false;
    // }
    state.page = 1;
    formInline.order_id = '';
    formInline.addressMobile = '';
    formInline.refundStatus = '1';
    formInline.refundType = '0';
    getList();
}

function tableSortChange({ order, prop }) {

    console.log('order---',order,prop)

    state.sort = order === 'ascending' ? 0 : order === 'descending' ? 1 : ''
    state.field = order ? prop : ''
    getList()
    // this.tableData.sort(compare(prop, order));
    // function compare(propertyName, sort) {
    //     return function (obj1, obj2) {
    //         var value1 = new Date(obj1[propertyName])
    //         var value2 = new Date(obj2[propertyName])
    //         if (typeof value1 === 'string' && typeof value2 === 'string') {
    //             const res = value1.localeCompare(value2, 'zh')
    //             return sort === 'ascending' ? res : -res
    //         } else {
    //             if (value1 <= value2) {
    //                 return sort === 'ascending' ? -1 : 1
    //             } else if (value1 > value2) {
    //                 return sort === 'ascending' ? 1 : -1
    //             }
    //         }
    //     }
    // }
}
// 退款的操作按钮
const openBtn = (type, row) => {
    state.drawType = type
    switch (type) {
        // 查看退款
        case 'look_refund':
            getRefundDetail({
                pro_id: row.pro_id,
                order_id: row.order_id,
                refund_id: row.refund_id
            }).then(async res => {
                if (res.status == 0) {
                    state.refundDetailObj = res.data
                    state.drawerTitle = '退款记录'
                    state.drawerVisibleLook_refund = true
                } else {
                    tools.confirm(res.message);
                }
            })
            break;
        // 有退款申请【跳退款审核详情页】
        case 'refunding':
            getRefundDetail({
                pro_id: row.pro_id,
                order_id: row.order_id,
                refund_id: row.refund_id
            }).then(async res => {
                if (res.status == 0) {
                    state.row = row
                    state.refundDetailObj = res.data
                    state.drawerTitle = '待处理退款'
                    openOpDialog(res.data.time)
                } else {
                    tools.confirm(res.message);
                }
            })
            break;
        // 退款成功
        case 'refund_pass':
            submit();
            break;
        // 退款驳回
        case 'refund_refuse':
            if (state.refund_refuse) {
                if (state.reason) {
                    submit();
                } else {
                    tools.toast('请填写拒绝理由');
                }
            } else {
                state.refund_refuse = true
                state.drawerTitle = '拒绝退款申请'
            }
            break;
    }
}
const openOpDialog = (time) => {
    //倒计时
    var day, hour, minute, second;
    // var x_time = + new Date(time);
    // var t_time = new Date().getTime();
    // var seco_re_time = x_time - t_time;
    clearTimeout(timer);
    var seco_re_time = time;
    if (seco_re_time > 0) {
        let ojb = convertSecondsToDHMS(seco_re_time)
        // remainTime = parseInt(seco_re_time);
        day = ojb.days;
        hour = ojb.hours;
        minute = ojb.minutes;
        second = ojb.seconds;
        countDown();
    } else {
        clearTimeout(timer);
    }
    state.drawerVisible = true
    function countDown() {
        seco_re_time--;
        state.contTimeTxt = day + '天' + hour + '时' + minute + '分' + second + '秒'
        if (seco_re_time == 0) {
            state.contTimeTxt = ''
            clearTimeout(timer);
            return false;
        } else {
            let ojb = convertSecondsToDHMS(seco_re_time)
            // remainTime = parseInt(seco_re_time);
            day = ojb.days;
            hour = ojb.hours;
            minute = ojb.minutes;
            second = ojb.seconds;
        }
        function countime() {
            timer = setTimeout(function () {
                countDown()
            }, 1000)
        }
        countime();
    }
    function convertSecondsToDHMS(seconds) {
        const days = Math.floor(seconds / (24 * 60 * 60));
        seconds %= (24 * 60 * 60);
        const hours = Math.floor(seconds / (60 * 60));
        seconds %= (60 * 60);
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;

        return {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: remainingSeconds
        };
    }
}
const submit = () => {
    let option = {
        pro_id: state.row.pro_id,
        refund_id: state.row.refund_id,
        agree: state.refund_refuse ? 0 : 1,
        reason: state.reason
    }
    postRefundAudit(option).then(async res => {
        if (res.status == 0) {
            // state.tableData.splice(0, state.tableData.length);
            // if (res.data) {
            //     state.tableData.push(...res.data);
            // }
            ElMessageBox.confirm(
                '操作成功',
                '提示',
                {
                    confirmButtonText: '确认',
                    cancelButtonText: '',
                    showCancelButton: false,
                }
            )
                .then(() => {
                    getList()
                })
            state.drawerVisible = false
            state.refund_refuse = false
        } else {
            tools.confirm(res.message);
        }
    })
}
// 检测订单退返现金额
const checkBackMessage = () => {
    if(!saleState.refund_amount){
        return false;
    }
    saleState.cashback_message = '';
    let option = {
        pro_id: pro_id,
        aftersale_id: saleState.aftersale_id,
        apply_amount: saleState.refund_amount
    }
    checkRefundCashback(option).then(async res => {
        if (res.status == 0 && res.data && res.data.show_msg) {
            saleState.cashback_message = res.data.show_msg;
        }
    })
}
// 售后单详情
const getSaleDetail = () => {
    // 查看售后单
    if (saleState.aftersale_type == 1 || saleState.aftersale_type == 2) {
        saleState.audit_info = [];
        saleState.imgList = [];
        saleState.videoList = [];
        saleState.auditImgList = [];
        saleState.auditVideoList = [];
        let option = {
            pro_id: pro_id,
            aftersale_id: saleState.aftersale_id
        }
        getSaleOrderDetail(option).then(async res => {
            if (res.status == 0) {
                closeSaleDialog();
                saleState.audit_info = res.data.audit_info;
                saleState.max_refund_amount = res.data.max_refund_amount;
                saleState.cashback_state = res.data.cashback_state; // 返现状态 0、无返现 1、已返现
                saleState.orderDetail = res.data;
                saleState.reissue_address = res.data.reissue_address;
                if(res.data.process_item_infos && res.data.process_item_infos.length > 0){
                    saleState.process_item_infos = [];
                    res.data.process_item_infos.forEach(infos => {
                        let items = infos;
                        items.videoList = [];
                        items.imgList = [];
                        if(infos.audit_attachment && JSON.parse(infos.audit_attachment).length > 0){
                            JSON.parse(infos.audit_attachment).forEach(ele => {
                                if(ele.file_type == 'video'){
                                    items.videoList.push(ele);
                                }else{
                                    items.imgList.push(ele.url);
                                }
                            })
                        }
                        saleState.process_item_infos.push(items);
                    })
                }
                if(res.data.apply_attachment && res.data.apply_attachment.length > 0){
                    res.data.apply_attachment.forEach(ele => {
                        if(ele.file_type == 'video'){
                            saleState.videoList.push(ele);
                        }else{
                            saleState.imgList.push(ele.url);
                        }
                    })
                }
                if(res.data.cs_apply_attachment && res.data.cs_apply_attachment.length > 0){
                    res.data.cs_apply_attachment.forEach(ele => {
                        if(ele.file_type == 'video'){
                            saleState.auditVideoList.push(ele);
                        }else{
                            saleState.auditImgList.push(ele.url);
                        }
                    })
                }
                if(res.data.send_back_address){
                    saleState.name = res.data.send_back_address.address_name;
                    saleState.mobile = res.data.send_back_address.address_mobile;
                    saleState.address = res.data.send_back_address.address;
                    saleState.province_id = res.data.send_back_address.province_id;
                    saleState.city_id = res.data.send_back_address.city_id;
                    saleState.area_id = res.data.send_back_address.area_id;
                    saleState.AddressData.forEach(e => {
                        if (e.id === saleState.province_id) {
                            saleState.AddressData1 = e.list
                            saleState.province = e.name
                            if (e.list) {
                                e.list.forEach(r => {
                                    if (r.id === saleState.city_id) {
                                        saleState.city = r.name
                                        saleState.AddressData2 = r.list
                                        if (r.list) {
                                            r.list.forEach(t => {
                                                if (t.id === saleState.area_id) {
                                                    saleState.county = t.name
                                                }
                                            })
                                        }
                                    }
                                })
                            }

                        }
                    })
                }else{
                    saleState.name = '';
                    saleState.mobile = '';
                    saleState.province = '';
                    saleState.city = '';
                    saleState.county = '';
                    saleState.AddressData1 = []
                    saleState.AddressData2 = []
                    saleState.AddressData3 = []
                    saleState.address = '';
                    saleState.province_id = '';
                    saleState.city_id = '';
                    saleState.area_id = '';
                }
                saleState.saleOpDrawerVisible = true;
            } else {
                tools.confirm(res.message);
            }
        })
    } else {
        saleState.work_cp_audit_info = [];
        saleState.work_cp_audit_info_proof = [];
        saleState.workProof = [];
        // 查看工单
        let option = {
            pro_id: pro_id,
            aftersale_id: saleState.aftersale_id
        }
        getWorkOrderDetail(option).then(async res => {
            if (res.status == 0) {
                // saleState.aftersale_type_name = res.data.aftersale_type_name;
                // if (res.data.work_cp_audit_info && res.data.work_cp_audit_info.audit_info) {
                //     saleState.work_cp_audit_info = res.data.work_cp_audit_info.audit_info;
                // }
                // if (res.data.work_cp_audit_info && res.data.work_cp_audit_info.audit_attachment) {
                //     let apply_list = []
                //     if (Array.isArray(res.data.work_cp_audit_info.audit_attachment)) {
                //         apply_list = res.data.work_cp_audit_info.audit_attachment
                //     } else {
                //         apply_list = JSON.parse(res.data.work_cp_audit_info.audit_attachment)
                //     }
                //     apply_list.forEach(ele => {
                //         if (ele.file_type === 'img') {
                //             saleState.work_cp_audit_info_proof.push(ele.url)
                //         }
                //     })
                // }
                saleState.orderDetail = res.data;
                // if (res.data.apply_attachment) {
                //     JSON.parse(res.data.apply_attachment).forEach(ele => {
                //         if(ele.file_type == 'img'){
                //             saleState.workProof.push(ele.url);
                //         }
                //     })
                // }
                saleState.workOrderDrawerVisible = true;
            } else {
                tools.confirm(res.message);
            }
        })
    }
}
// 售后单日志
const getSaleLog = () => {
    let option = {
        pro_id: pro_id,
        aftersale_id: saleState.aftersale_id
    }
    getSaleOrderLog(option).then(async res => {
        if (res.status == 0) {
            saleState.orderLogList = [];
            saleState.orderLogList.push(...res.data.list)
            saleState.saleLogDrawerVisible = true;
        } else {
            tools.confirm(res.message);
        }
    })
}
// 售后单审核
const orderAudit = () => {
    if(!saleState.isExamine){
        closeSaleDialog();
        return false;
    }
    // 部分退款校验
    if(saleState.opType == 1 && saleState.examine == 3){
        if(!saleState.refund_amount){
            tools.toast('请输入退款金额');
            return false;
        }
        if(saleState.refund_amount && Number(saleState.refund_amount) > Number(saleState.max_refund_amount)){
            tools.toast('输入的退款金额大于剩余可结算金额');
            return false;
        }
    }
    // 换货校验
    if(saleState.opType == 2 && saleState.examine == 3){
        if(!saleState.name || !saleState.mobile || !saleState.address || !saleState.province_id || !saleState.city_id || !saleState.area_id){
            tools.toast('请补充完整的寄回地址信息');
            return false;
        }
    }
    // 拒绝申请检验
    if(saleState.examine == 2 && !saleState.reason){
        tools.toast('请输入拒绝原因');
        return false;
    }

    const executeAudit = () => {
        state.loading = true;
        let option = {
            pro_id: pro_id,
            aftersale_id: saleState.aftersale_id,
            process_type: saleState.opType, // 1、部分退款 2、换货 3、补发 4、沟通解决
            audit_status: saleState.examine, // 2、同意 3、驳回
        }
        if(saleState.examine == 2){
            option.audit_content = saleState.reason;
            option.refund_amount = '';
            option.address = '';
        }else{
            if(saleState.opType == 1){
                option.audit_content = '';
                option.refund_amount = saleState.refund_amount;
                option.address = '';
            }else if(saleState.opType == 2){
                option.audit_content = '';
                option.refund_amount = '';
                let addressObj = {
                    address_name: saleState.name,
                    address_mobile: saleState.mobile,
                    address_email: '',
                    country_code: '',
                    country_name: '',
                    province: saleState.province,
                    city: saleState.city,
                    county: saleState.county,
                    street: '',
                    address: saleState.address,
                    address_postal_code: '',
                    province_id: saleState.province_id,
                    city_id: saleState.city_id,
                    area_id: saleState.area_id,
                    street_id: ''
                }
                option.address = JSON.stringify(addressObj);
            }else{
                option.audit_content = '';
                option.refund_amount = '';
                option.address = '';
            }
        }
        postOrderAudit(option).then(res => {
            state.loading = false;
            if (res.status == 0) {
                tools.confirm({
                    msg: res.message || '操作成功'
                },() => {
                    getAfterSaleList();
                    saleState.saleOpDrawerVisible = false;
                })
            } else {
                tools.confirm(res.message);
            }
        })
    }
    if (saleState.opType == 1 && saleState.examine == 3 && saleState.cashback_message) {
        tools.confirm({
            title: '提示',
            msg: saleState.cashback_message,
            hasCancel: true,
            success: '继续提交',
            cancel: '取消'
        }, () => {
            executeAudit();
        }, () => {
            console.log("用户取消了提交");
        });
    } else {
        executeAudit();
    }
}
// 发货预填地址字段
const getDeliverbefore = () => {
    saleState.express_company = '';
    saleState.express_no = '';
    let option = {
        pro_id: pro_id,
        aftersale_id: saleState.aftersale_id
    }
    getSaleOrderDetail(option).then(async res => {
        if (res.status == 0) {
            saleState.reissue_address = res.data.reissue_address;
            saleState.deliverDrawerVisible = true;
        } else {
            tools.confirm(res.message);
        }
    })
}
// 售后的操作按钮
const openSaleOpBtn = (type, row) => {
    saleState.isExamine = true;
    saleState.to_user_id = row.user_id_and_nickname && row.user_id_and_nickname.split('/')[0] || 0
    saleState.aftersale_type = row.aftersale_type;
    saleState.aftersale_id = row.aftersale_id;
    saleState.userId = row.userId;
    switch (type) {
        // 查看
        case 'md_aftersale_find':
            saleState.isExamine = false;
            getSaleDetail()
            break;
        // 日志
        case 'md_aftersale_log':
            getSaleLog();
            break;
        // 处理（售后）
        case 'md_aftersale_process':
            saleState.isExamine = true;
            getSaleDetail();
            break;
        // 发货
        case 'md_aftersale_deliver':
            getDeliverbefore();
            break;
        // 上传协商凭证
        case 'md_aftersale_add_nego':
            saleState.appealNegoAddDrawerVisible = true;
            break;
        // 协商历史
        case 'md_aftersale_nego_log':
            getAppealNegoLog();
            break;

    }
}
// 售后单发货
const postDeliver = () => {
    if (!saleState.express_company) {
        tools.toast('请选择物流公司');
        return false;
    }
    if (!saleState.express_no) {
        tools.toast('请填物流单号');
        return false;
    }
    state.loading = true;
    let option = {
        pro_id: pro_id,
        aftersale_id: saleState.aftersale_id,
        express_no: saleState.express_no,
        express_company: saleState.express_company
    }
    postOrderDeliver(option).then(res => {
        state.loading = false;
        if (res.status == 0) {
            tools.confirm({
                msg: res.message || '操作成功'
            },() => {
                getAfterSaleList();
                saleState.deliverDrawerVisible = false;
            })
        } else {
            tools.confirm(res.message);
        }
    })
}
// 关闭工单弹窗
const closeWorkDialog = () => {
    saleState.workOrderDrawerVisible = false;
    saleState.audit_attachment = '';
    saleState.audit_content = [];
}
const handleClose = (done) => {
    closeWorkDialog();
    done()
}

const workOrderAudit = () => {
    if (!saleState.audit_attachment) {
        tools.toast('请填写处理依据');
        return false;
    }
    if (!saleState.audit_content) {
        tools.toast('请上传处理凭证 ');
        return false;
    }
    state.loading = true;
    let proof = ''
    if (saleState.audit_content && saleState.audit_content.length > 0) {
        proof = []
        saleState.audit_content.forEach(ele => {
            proof.push({
                file_type: 'img',
                url: ele
            })
        })
    }
    let option = {
        pro_id: pro_id,
        aftersale_id: saleState.aftersale_id,
        audit_content: saleState.audit_attachment,
        audit_attachment: proof ? JSON.stringify(proof) : '',
        admin_user_name: saleState.admin_user_name
    }
    postWorkOrderAudit(option).then(res => {
        state.loading = false;
        if (res.status == 0) {
            tools.confirm({
                msg: res.message || '操作成功'
            },() => {
                getAfterSaleList();
                saleState.workOrderDrawerVisible = false;
            })
        } else {
            tools.confirm(res.message);
        }
    })
}

/****** 上传协商凭证 ******/

// 上传协商凭证Drawer关闭
const handleCloseAppealNegoDrawer = () => {
    saleState.appealNegoAddDrawerVisible = false;
    saleState.appealNegoAddContent = '';
    saleState.appealNegoAddImages = [];
}

// 点击上传协商信息
const handleSubmitAppealNegoInfo = () => {

    if (!saleState.appealNegoAddContent) {
        tools.toast('请填写协商结果');
        return false;
    }
    state.loading = true;
    let proof = ''
    if (saleState.appealNegoAddImages && saleState.appealNegoAddImages.length > 0) {
        proof = []
        saleState.appealNegoAddImages.forEach(ele => {
            proof.push({
                file_type: 'img',
                url: ele
            })
        })
    }
    let option = {
        aftersale_id: saleState.aftersale_id,
        content: saleState.appealNegoAddContent,
        attachment: proof ? JSON.stringify(proof) : '',
        pro_id: pro_id
    }
    postAppealNegoAddInfo(option).then(res => {
        state.loading = false;
        if (res.status == 0) {
            tools.confirm({
                msg: res.message || '操作成功'
            },() => {
                getAfterSaleList();
                handleCloseAppealNegoDrawer()
            })
        } else {
            tools.confirm(res.message);
        }
    })
}

// 协商历史
const getAppealNegoLog = () => {
    let option = {
        aftersale_id: saleState.aftersale_id,
        pro_id: pro_id
    }
    getAppealNegoLogInfo(option).then(async res => {
        if (res.status == 0) {
            saleState.appealLogList = [];
            saleState.appealLogList.push(...res.data.list)
            saleState.appealNegoLogDrawerVisible = true;
        } else {
            tools.confirm(res.message);
        }
    })
}


// 售后清空按钮
const empty = () => {
    saleState.userType = 1;
    formAfterSale.aftersale_id = '';
    formAfterSale.order_id = '';
    formAfterSale.name = '';
    formAfterSale.mobile = '';
    formAfterSale.uid = '';
    formAfterSale.nickname = '';
    formAfterSale.apply_reson_type = 0;
    formAfterSale.cp_audit_status = 0;
    formAfterSale.user_type = 0;
    formAfterSale.status = 0;
    formAfterSale.aftersale_type = 0;
    formAfterSale.query_type = 0;
    formAfterSale.query_data = '';
    formAfterSale.process_type = 0;
    formAfterSale.aftersale_deliver_status = 0;
}
// 退款订单的导出
const exportExcexTab1 = async () => {
    if (state.tableData && state.tableData.length == 0) {
        tools.toast('无可下载数据');
        return false;
    }
    const option = {
        pro_id: pro_id,
        page: state.page,
        page_size: state.page_size,
        order_id: formInline.order_id,
        addressMobile: formInline.addressMobile,
        refundStatus: Number(formInline.refundStatus),
        refundType: Number(formInline.refundType),
        sort: state.sort,
        field: state.field
    }
    const { data: item, status, message } = await getManagerDownload(option)
    if (status == 0) {
        step1Pop.value = true
        get_deliver_time();
    }else{
        tools.confirm(message);
    }
    async function get_deliver_time() {
        const { data, status, message} = await getQueryManagerDownload({ check_key: item.checkKey, pro_id: pro_id })
        if(status == 0){
            saleState.exportExcexRate = data.rate
            if (data && data.rate != 100) {
                saleState.step1TimeOut = setTimeout(() => {
                    get_deliver_time();
                }, saleState.deliverWait);
            }
            if (data.rate == 100) {
                downloadFile(data.downloadUrl, '订单')
                clearTimeout(saleState.step1TimeOut);
            }
        }else{
            tools.confirm(message);
        }
    }
}
// 导出
const exportExcex = async () => {
    if (saleState.saleTableData && saleState.saleTableData.length == 0) {
        tools.toast('无可下载数据');
        return false;
    }
    const option = Object.assign({
        pro_id: pro_id,
    }, formAfterSale)
    const { data, status, message } = await getSaleOlderExport(option)
    if (status == 0) {
        downloadFile(data, '订单')
        // step1Pop.value = true
        // get_deliver_time();
    }else{
        tools.confirm(message);
    }
    // async function get_deliver_time() {
    //     const { data } = await getQuerySaleOlderExport({ check_key: item.checkKey, pro_id: pro_id })
    //     saleState.exportExcexRate = data.rate
    //     if (data && data.rate != 100) {
    //         saleState.step1TimeOut = setTimeout(() => {
    //             get_deliver_time();
    //         }, saleState.deliverWait);
    //     }
    //     if (data.rate == 100) {
    //         downloadFile(data.downloadUrl, '订单')
    //         clearTimeout(saleState.step1TimeOut);
    //     }
    // }
}
function downloadFile(url, fileName) {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
// 关闭售后的审核弹窗
const closeSaleDialog = () => {
    // 清空选项
    saleState.examine = ''
    saleState.opType = ''
    saleState.AddressData1 = []
    saleState.province = ''
    saleState.city = ''
    saleState.AddressData2 = []
    saleState.AddressData3 = []
    saleState.city_id = ''
    saleState.area_id = ''
    saleState.refund_amount = ''
    saleState.address = ''
    saleState.name = ''
    saleState.mobile = ''
    saleState.reason = ''
    saleState.saleOpDrawerVisible = false
    saleState.cashback_message = ''
}
// 头部切换售后
const goComplainManage = index => {
    empty();
    // formAfterSale.cp_audit_status = 1;
    // formAfterSale.user_type = index;
    formAfterSale.aftersale_type = index;
    state.pageType = 1;
    getAfterSaleList();
    // router.push({
    //     name:'complain_manage',
    //     params:{
    //         id:pro_id
    //     }
    // });
}
// 联系客服
const goHelpCenter = () => {
    let newTab = window.open('about:blank');
    newTab.location.href = domain_zhongchou + '/helpcenter/reply';
}
// 用户手机号校验
const handleMobileInput = () => {
    formAfterSale.query_data = formAfterSale.query_data.replace(/\D/g, "");
    if (formAfterSale.query_data.length > 11) {
        formAfterSale.query_data = formAfterSale.query_data.slice(0, 11);
    }
}
const handleDeliverMobileInput = () => {
    saleState.mobile = saleState.mobile.replace(/\D/g, "");
    if (saleState.mobile.length > 11) {
        saleState.mobile = saleState.mobile.slice(0, 11);
    }
}
// 退款金额
const handleMoneyInput = event => {
    const inputValue = String(event || ''); // 当前输入值，确保为字符串
    clearTimeout(moneyInputTimer); // 清除上一个定时器

    let value = inputValue;

    // 1. 清除非数字字符，但保留第一个小数点
    value = value.replace(/[^\d.]/g, ""); 
    value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.'); // 确保只有一个小数点

    // 2. 如果值以小数点开头，则在前面补 '0'
    if (value.startsWith('.')) {
        value = '0' + value;
    }

    // 3. 限制小数点后最多两位
    if (value.includes('.')) {
        const parts = value.split('.');
        if (parts.length > 1 && parts[1].length > 2) {
            parts[1] = parts[1].substring(0, 2);
            value = parts.join('.');
        }
    }

    // 4. 移除无效的前导零 (例如 "007" -> "7", 但 "0.5" 或 "0" 保持不变)
    if (value.length > 1 && value.startsWith('0') && !value.startsWith('0.')) {
        let strippedValue = value.replace(/^0+/, '');
        // 如果移除前导零后为空字符串 (例如原值为 "00"), 则恢复为 "0"
        value = strippedValue === "" ? "0" : strippedValue;
    }

    // 5. 处理完全无效的输入或仅剩 "0." 的情况
    // 如果经过处理后，值为空字符串 (例如原输入为 "abc")，则直接更新为空并返回
    // 允许用户输入 "0." 作为中间状态
    if (value === "" && inputValue !== "0.") { // inputValue check preserves explicit "0."
        saleState.refund_amount = "";
        saleState.cashback_message = '';
        return; 
    }
    
    // 6. 应用最大值限制
    let finalValue = value; // 默认使用处理后的值
    const numericValue = parseFloat(value); // parseFloat("0.") is 0, parseFloat("") is NaN
    const maxAmount = parseFloat(saleState.max_refund_amount);

    if (!isNaN(numericValue) && !isNaN(maxAmount) && numericValue > maxAmount) {
        finalValue = maxAmount.toFixed(2);
    }
    // 如果value是 "0." 并且没有超过maxAmount, finalValue会是 "0."
    // 如果value是 "" (且inputValue也是""), parseFloat(value)是NaN, 不会进入maxAmount逻辑, finalValue是""
    
    saleState.refund_amount = finalValue;

    // 7. 设置新的定时器以调用 checkBackMessage (节流)
    const currentRefundNumeric = parseFloat(saleState.refund_amount);
    if (saleState.refund_amount && !isNaN(currentRefundNumeric) && currentRefundNumeric > 0) {
        moneyInputTimer = setTimeout(() => {
            checkBackMessage();
        }, 500); // 500毫秒延迟
    } else {
        // 如果最终金额为0、空或无效，清空返现消息
        saleState.cashback_message = '';
    }
}
// 省市区
const changeProvince = event => {
    saleState.AddressData.forEach(e => {
        if (e.id === event) {
            saleState.AddressData1 = e.list
            saleState.province = e.name
            saleState.city = ''
            saleState.AddressData2 = []
            saleState.AddressData3 = []
            saleState.city_id = ''
            saleState.area_id = ''
        }
    })
}
const changeCity = event => {
    saleState.AddressData1.forEach(e => {
        if (e.id === event) {
            saleState.area_id = ''
            saleState.AddressData3 = []
            saleState.city = e.name
            saleState.AddressData2 = e.list
        }
    })
}
const changeArea = event => {
    saleState.AddressData2.forEach(e => {
        if (e.id === event) {
            saleState.county = e.name
        }
    })
}
// 私信
function rongim(id) {
    window.open(`https://account.modian.com/RongIM?user_id=${id}`)
}
// 物流公司
const getExperssList = async () => {
    const { data } = await getExpressCompanyList({ json_type: 'json' })
    saleState.expressOptions = data
}
// 地址列表
const getAddressDataFn = async () => {
    const { data } = await getAddressData({ json_type: 'json' })
    saleState.AddressData = data
}
// 退款页脚
const changePage = (e) => {
    state.page = e
    getList()
}
const changePagesize = (e) => {
    state.page_size = e
    getList()
}
// 售后页脚
const changeSalePage = (e) => {
    saleState.salePage = e
    getAfterSaleList()
}
const changeSalePagesize = (e) => {
    saleState.salePageSize = e
    getAfterSaleList()
}
const relatedOrder = (id) => {
    formAfterSale.order_id = id
    formAfterSale.aftersale_type = 0
    getAfterSaleList()
}
const uploaderChild = ref(null);
const handleSuccess = (res) => {
    if (saleState.appealNegoAddDrawerVisible) {
        saleState.appealNegoAddImages.push(res);
    } else {
        saleState.audit_content.push(res)
    }
}
const coverClick = () => {
    uploaderChild.value.onClick();
}
const getVideo = async (url) => {
    saleState.videoUrl = ''
    const { code, data } = await showVideoList({url:url})
    if (code === 0 && data && data.list) {
        saleState.videoUrl = data.list[data.default];
        saleState.innerDrawer = true;
    }
}
</script>
<style lang="scss" scoped>
.colTop{
    padding-top: 20px;
}
.box {
    .main-wrap {
        margin: 0 auto;

        .member_inner {
            background: #fff;
            min-width: 886px;
            border-radius: 8px;
            padding: 20px 20px 0;
            
            ::v-deep .el-drawer {
                .el-drawer__title {
                    i {
                        font-size: 15px;
                        padding: 0 5px 0 0;
                    }

                    span {
                        padding: 0 0 0 20px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #7F7F7F;
                        line-height: 14px;
                    }
                }

                .el-textarea__inner {
                    height: 100px;
                }

                .el-drawer__body {
                    .title {
                        padding: 30px 0 10px 0;
                        font-size: 16px;
                        font-family: PingFang SC-中粗体, PingFang SC;
                        font-weight: 600;
                        color: #222C37;
                        line-height: 16px;

                        &.top {
                            padding: 0 0 10px 0;
                        }

                        .required {
                            color: rgba(255, 61, 32, 1);
                        }
                    }

                    >p {
                        padding: 8px 0 0 0;
                        font-size: 14px;
                        font-weight: 400;
                        color: #222C37;
                        line-height: 21px;

                        &:first-child {
                            padding: 0;
                        }
                    }

                    .detail {
                        background: #F8F8F8;
                        padding: 3px 20px 18px 20px;

                        .column {
                            padding: 13px 0 0 0;
                            display: flex;
                            align-items: flex-start;

                            label {
                                text-align: right;
                                width: 84px;
                                min-width: 84px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #7F7F7F;
                                line-height: 21px;
                            }

                            p {
                                width: 416px;
                                padding: 0 0 0 20px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #1A1A1A;
                                line-height: 21px;
                            }
                        }
                    }

                    // 售后
                    .afterSaleDrawerContent {
                        &.deliver {
                            .saleApplyInfo .col>p {
                                width: 76px;
                            }

                            .saleApplyInfo .col>.right {
                                width: calc(100% - 78px);
                            }

                            .el-select {
                                width: 100%;

                                .el-input {
                                    margin: 0;
                                }
                            }

                            .el-input {
                                margin: 10px 0 0 0;

                                .el-input__inner {
                                    height: 40px;
                                }
                            }
                        }

                        .title {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 0 0 10px 0;

                            p {
                                font-size: 16px;
                                font-weight: 500;
                                color: #1A1A1A;
                                line-height: 16px;

                                i {
                                    color: #FF3535;
                                    font-style: normal;
                                }
                            }
                        }

                        .saleApplyInfo {
                            width: 100%;
                            padding: 20px 10px;
                            background: #F8F8F8;
                            border-radius: 6px;

                            .col {
                                display: flex;
                                justify-content: space-between;
                                align-items: flex-start;

                                &:nth-child(n+2) {
                                    padding: 17px 0 0 0;
                                }

                                >p {
                                    padding: 3px 20px 0 0;
                                    width: 98px;
                                    text-align: right;
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #7F7F7F;
                                    line-height: 14px;
                                    flex-shrink: 0;
                                }

                                >.right {
                                    width: calc(100% - 118px);

                                    p {
                                        text-align: left;
                                        font-size: 14px;
                                        font-weight: 400;
                                        color: #1A1A1A;
                                        line-height: 21px;
                                    }

                                    .proof {
                                        display: flex;
                                        align-items: center;
                                        padding: 7px 0 0 0;

                                        >div {
                                            width: 64px;
                                            height: 64px;
                                            border-radius: 4px;
                                            border: 1px solid #E8E8E8;

                                            &:nth-child(-n+6) {
                                                margin: 0 8px 0 0;
                                            }
                                            &.videoItem{
                                                position: relative;
                                                .video_bg{
                                                    position: absolute;
                                                    left: 0;
                                                    top: 0;
                                                    width: 100%;
                                                    height: 100%;
                                                    background: rgba(0,0,0,0.6);
                                                    cursor: pointer;
                                                    display: flex;
                                                    align-items: center;
                                                    justify-content: center;
                                                    color: #fff;
                                                    font-size: 28px;
                                                }
                                            }
                                            .el-image{
                                                width: 100%;
                                                height: 100%;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        .examine {
                            display: flex;
                            align-items: center;
                            padding: 20px 0 10px 0;
                        }

                        .left_title {
                            font-size: 14px;
                            font-weight: 400;
                            color: #1A1A1A;
                            line-height: 14px;
                            width: 128px;

                            i {
                                color: #FF3535;
                                font-style: normal;
                            }
                        }

                        .audit_content {
                            display: grid;
                            grid-gap: 0 10px;
                            grid-template-columns: repeat(4, auto);
                            >div {
                                width: 87px;
                                height: 87px;
                                border-radius: 4px;
                                border: 1px solid #E8E8E8;
                                position: relative;
                                &:nth-child(-n+6) {
                                    margin-right: 8px;
                                }
                                &:nth-child(n+5) {
                                    margin-top: 8px;
                                }
                                &:hover{
                                    .op{
                                    opacity: 1;
                                    }
                                }
                            }
                            img{
                                width: 100%;
                                height: 100%;
                                object-fit: contain;
                            }
                            .op{
                                opacity: 0;
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 100%;
                                height: 100%;
                                background: rgba(0,0,0,0.6);
                                cursor: pointer;
                                i{
                                    font-size: 16px;
                                    position: absolute;
                                    top: 6px;
                                    right: 6px;
                                    color: #fff;
                                }
                            }
                            .upload {
                                background: #FFFFFF;
                                border: 1px dashed #E8E8E8;
                                cursor: pointer;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;

                                i {
                                    font-size: 16px;
                                    color: #7F7F7F;
                                }

                                >p {
                                    font-size: 12px !important;
                                    padding: 10px 0 0 0;
                                    font-weight: 400;
                                    color: #7F7F7F !important;
                                    line-height: 12px !important;
                                }
                            }
                        }

                        .saleOpBottom {
                            padding: 20px 10px;
                            background: #F8F8F8;

                            .left_title {
                                width: 118px;
                                flex-shrink: 0;
                            }

                            .tips {
                                font-size: 14px;
                                padding: 7px 0 0 118px;
                                font-weight: 400;
                                color: #7F7F7F;
                                line-height: 21px;
                                &.cashback_state{
                                    padding: 7px 0 0 118px;
                                    color: #F58500;
                                }
                            }

                            .extraAddress {
                                padding: 0 0 0 118px;

                                .el-input {
                                    margin: 10px 0 0 0;

                                    .el-input__inner {
                                        height: 40px;
                                    }
                                }
                            }

                            .col {
                                display: flex;
                                align-items: center;

                                &.bottom {
                                    margin: 20px 0 0 0;
                                }

                                &.start {
                                    align-items: flex-start;
                                }
                                .el-radio-group .el-radio:last-child{
                                    margin: 0;
                                }
                                .refund_amount {
                                    width: 270px;
                                    border: 1px solid #E8E8E8;
                                    border-radius: 4px;

                                    &:hover {
                                        border: 1px solid #1A1A1A;
                                    }

                                    .el-input__wrapper {
                                        box-shadow: none;

                                        .el-input__inner {
                                            height: 40px;
                                        }
                                    }

                                    .el-input-group__append {
                                        box-shadow: none;
                                        background: #fff;
                                    }
                                }

                                .gridAddress {
                                    width: 100%;
                                    display: grid;
                                    grid-template-columns: 160px auto;
                                    grid-gap: 0 10px;
                                    grid-template-columns: repeat(3, auto);

                                    .el-input__inner {
                                        height: 40px;
                                    }
                                }

                                p {
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #222C37;
                                    line-height: 14px;

                                    &.address {
                                        padding: 9px 0 0 0;
                                        line-height: 21px;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            ::v-deep .cont-nothing-box {
                padding: 42px 0;
            }

            .header {
                padding: 20px 0;
                font-size: 20px;
                font-weight: 500;
                line-height: 20px;
                color: #1A1A1A;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .top_tips{
                width: 100%;
                padding: 15px;
                background: #FFF8EE;
                border-radius: 4px;
                display:flex;
                align-items:center;
                p{
                    padding-left:6px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #F5A728;
                    line-height: 24px;
                }
                i{
                    font-size:18px;
                    color:#F5A728;
                }
            }
            .statistics {
                display: flex;
                padding: 20px 0;

                >div {
                    margin:5px;
                    width: 150px;
                    height: 80px;
                    border-radius: 6px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    &:hover,&.active{
                        background: #F2F2F2;
                    }
                    &:nth-child(n+2) {
                        position: relative;

                        &::after {
                            content: '';
                            position: absolute;
                            width: 1px;
                            height: 50px;
                            background: #E8E8E8;
                            left: -5px;
                            top: 50%;
                            transform:translateY(-50%);
                        }
                    }

                    // &:last-child {
                    //     p {
                    //         padding: 7px 0 0 0;
                    //     }

                    // }

                    p {
                        font-size: 14px;
                        font-weight: 400;
                        color: #1A1A1A;
                        line-height: 14px;
                        padding: 14px 0 0 0;
                        display:flex;
                        align-items:center;
                        i{
                            padding-left:6px;
                        }
                        &.num {
                            padding: 0;
                            font-size: 18px;
                            font-weight: 600;
                            color: #1A1A1A;
                            line-height: 18px;
                            &.other{
                                    color: #B1B1B1;
                                &.striking{
                                    color: #FF3535;
                                }
                            }
                        }
                    }

                    span {
                        padding: 6px 0 0 0;
                        font-size: 12px;
                        font-weight: 400;
                        color: #7F7F7F;
                        line-height: 12px;
                    }
                }
            }

            ::v-deep(.el-form) {
                .inputSelect{
                    .el-input{
                        border-radius: 0 4px 4px 0 !important;
                    }
                    .el-select{
                        .el-input.el-input--suffix{
                            border-radius: 4px 0 0 4px !important;
                            border-right: none !important;
                            &:hover {
                                border: 1px solid #1A1A1A !important;
                            }
                        }
                    }
                }
                .el-select.title {
                    max-width: 136px;

                    .el-input {
                        width: 100%;
                    }
                }

                .el-form-item {
                    margin: 0 20px 20px 0;
                    &.boldTitle label{
                        font-weight:700;
                    }
                }

                .el-form-item__label {
                    font-size: 16px;
                    font-weight: 400;
                    color: #1A1A1A;
                    height: 40px;
                    line-height: 40px;
                    box-sizing: content-box;
                }
                .el-form-item__content .el-select {
                    width: 220px;
                    height: 40px;
                    background: #FFFFFF;
                }

                .el-form-item__content .el-input {
                    width: 220px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    border: 1px solid #E8E8E8;

                    &:hover {
                        border: 1px solid #1A1A1A;
                    }

                    .el-input__wrapper {
                        padding: 0 12px;
                        box-shadow: none;

                        .el-input__inner {
                            width: 100%;
                            height: 100%;
                            font-size: 14px;
                            color: #1A1A1A;
                        }
                    }
                }
            }

            .tips_field {
                margin: 20px 0;
                background: #F2F2F2;
                border-radius: 4px;
                color: #7F7F7F;
                padding: 15px 40px;
                font-size: 14px;
                line-height: 1.5;

                &.afterSale {
                    padding: 15px;
                    display: flex;
                    align-items: center;

                    i {
                        font-size: 18px;
                    }

                    >div {
                        padding: 0 6px;
                        width: calc(100% - 110px);
                    }
                }
            }

            .empty,
            .table {
                border-top: 1px solid #E8E8E8;
            }

            .table {
                min-height: 500px;
                width: 100%;
            }
        }
    }
}

.userInfo {
    .info {
        display: block !important;
        max-width: 110px;
    }
}

.appealLogItem {
    background: #f7f7f7;
    padding: 10px 10px 15px;
    border-radius: 5px;
    border: 1px dashed #DEDEDE;
    margin-bottom: 10px;

    .item {
        margin-top: 5px;
        display: flex;

        .left-title {
            min-width: 80px;
            font-weight: 500;
        }

        .images {
            display: flex;
            margin-top: 5px;

            .big-image {
                width: 80px;
                height: 80px;
                margin-right: 5px;
                border-radius: 5px;
            }
        }

    }

    
}

::v-deep(.el-radio) {
    margin-right: 16px;
    padding: 0 10px !important;
}

::v-deep(.el-pagination) {
    height: 70px;
}

::v-deep(.el-table th.el-table__cell) {
    height: 48px;
    background: #F8F8F8;

    .cell {
        font-size: 14px;
        color: #7F7F7F;
        padding: 0 10px 0 18px;
    }
}

::v-deep(.el-table .el-table__cell) {
    z-index: auto;
}

::v-deep(.el-table td) {
    font-size: 14px;
    color: #222C37;
    line-height: 21px;

    .cell {
        padding: 0 10px 0 18px;

        .info {
            display: flex;
            align-items: center;

            >p {
                font-size: 14px;
                font-weight: 400;
                color: #222C37;
                line-height: 21px;
            }
        }
    }
}

::v-deep(.el-button--small) {
    i {
        padding: 0 8px 0 0;
    }
}

::v-deep(.el-link.is-disabled) {
    color: var(--el-link-disabled-text-color);
    cursor: not-allowed;
}
</style>
